import { render, staticRenderFns } from "./ModalTeacherCreate.vue?vue&type=template&id=235ff530&scoped=true&"
import script from "./ModalTeacherCreate.vue?vue&type=script&lang=js&"
export * from "./ModalTeacherCreate.vue?vue&type=script&lang=js&"
import style0 from "./ModalTeacherCreate.vue?vue&type=style&index=0&id=235ff530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235ff530",
  null
  
)

export default component.exports